import { render, staticRenderFns } from "./HorizentalBarChart.vue?vue&type=template&id=66c8e0da&scoped=true&"
import script from "./HorizentalBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizentalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c8e0da",
  null
  
)

export default component.exports